module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15ct8Jn/CoverDesign.jpg?1685327251464",
      "alt": "This image is the cover for the book Feather and Scroll, The Shifter Chronicles"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Feather and Scroll, The Shifter Chronicles\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("The Shifter Chronicles: Book Eleven")])])]), _c('p', [_vm._v("Agent Pan has spent most of his adult life protecting shape-shifters from the Knights—an organization bent on their annihilation—and keeping the secret war in the shadows where it belongs. But the Knights are growing bolder, and a new threat has resurfaced after being buried in the ocean for decades.")]), _vm._v(" "), _c('p', [_vm._v("An ancient scroll, a key to a devastating weapon, is now in the hands of a recalcitrant Russian hawk shifter named Viktor. As a bird shifter, he knows his duty is to protect the scroll, but he wants nothing to do with the war. He leads a quiet life and wants to keep it that way. But when agents come knocking on his door, he finds it difficult to resist the charms of Agent Pan, especially since this isn’t their first meeting.")]), _vm._v(" "), _c('p', [_vm._v("Two years earlier they spent a passionate weekend together, neither aware of the other’s true identity. Viktor never really got over Pan. Now with sexual tension at its peak, they must learn to trust each other and work as a team to protect not only their loved ones, but every shifter in the world.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      M.D. Grimm\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0